import { Component, Input, OnInit } from '@angular/core';
import { ActionPriority } from 'src/app/performance-dashboard/model/performance.model';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-action-priority',
  templateUrl: './action-priority.component.html',
  styleUrls: ['./action-priority.component.css']
})
export class ActionPriorityComponent implements OnInit {
  @Input() ActionPriorityData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedActionPriorityData: { [s: string]: ActionPriority } = {};
  ACTPrData : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {
  }

  onRowEditInit(actionPriority: ActionPriority) {
    this.clonedActionPriorityData[actionPriority.id] = { ...actionPriority };
    this.DisableExport = true;
  }

  onRowEditSave(actionPriority: ActionPriority) {
    if (actionPriority) {
      let newActionPriorityData = [];
      this.ActionPriorityData.forEach(element => {
        if(element.category !== "Total")
        newActionPriorityData.push(element);
      });

      this.ActionPriorityData[this.ActionPriorityData.length - 1].Low = newActionPriorityData.reduce((acc, cur) => acc + cur.Low, 0);
      this.ActionPriorityData[this.ActionPriorityData.length - 1].Medium = newActionPriorityData.reduce((acc, cur) => acc + cur.Medium, 0);
      this.ActionPriorityData[this.ActionPriorityData.length - 1].High = newActionPriorityData.reduce((acc, cur) => acc + cur.High, 0);

      delete this.clonedActionPriorityData[actionPriority.id];
      //this.messageService.add({severity:'success', summary: 'Success', detail:'Product is updated'});
    } else {
      //this.messageService.add({severity:'error', summary: 'Error', detail:'Invalid Price'});
    }
    this.DisableExport = Object.keys(this.clonedActionPriorityData).length > 0 ? true : false;
  }

  onRowEditCancel(actionPriority: ActionPriority, index: number) {
    this.ActionPriorityData[index] = this.clonedActionPriorityData[actionPriority.id];
    delete this.clonedActionPriorityData[actionPriority.id];
    this.DisableExport = Object.keys(this.clonedActionPriorityData).length > 0 ? true : false;
  }

  GetActionPrioritySelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Action Priority",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetActionPrioritySelectedDetails.bind(this));
  }
  callbackMethodForGetActionPrioritySelectedDetails(response){
    if(response.Success)
    this.ACTPrData = response.Result;
  }

  Redirect(value,processId)
  {
  //this.router.navigate(['/actiontracker/all-action-details', value, { processId:processId }])
  window.open(ConstantsService.URL.APP + ['/actiontracker/all-action-details/'+value+';processId='+processId], '_self');
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('ActionPriorityTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('E','D');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "ActionPriority.xlsx");

  }
  //EOC Pritesh

}
